import imageCompression from 'browser-image-compression';

/**
 * Compress a file only if it's larger than the max size.
 * @param {File} file - The original image file.
 * @param {number} maxSizeMB - Maximum size in MB (default is 2MB).
 * @returns {Promise<File>} - Compressed file or original if small enough.
 */
export const compressImageIfNeeded = async (file, maxSizeMB = 2) => {
    if (file && file instanceof File && file.size > maxSizeMB * 1024 * 1024) {
        try {
            const compressedFile = await imageCompression(file, {
                maxSizeMB,
                maxWidthOrHeight: 1000,
                useWebWorker: true,
            });
            return compressedFile;
        } catch (error) {
            console.error('Image compression failed:', error);
            return file;
        }
    }
    return file;
};
